import { computed, ref } from "vue";
import { type CategoryId, CategoryId_Schema } from "@/services/collection/categories/categoriesSchema";
import { getCookie, setCookie } from "@/services/cookies";

const COOKIE_NAME = "colectio_remembered_category";
const COOKIE_EXPIRATION_DAYS = 365;

function getCookieExpiration(): string {
  const date = new Date();
  date.setDate(date.getDate() + COOKIE_EXPIRATION_DAYS);
  return date.toUTCString();
}

const _categoryId = ref<CategoryId | null>(parseCategoryFromCookie());

function parseCategoryFromCookie(): CategoryId | null {
  const raw = getCookie(COOKIE_NAME);
  if (!raw) return null;

  const parsed = CategoryId_Schema.safeParse(Number(raw));
  return parsed.success ? parsed.data : null;
}

export function useRememberedCategory() {
  const rememberedCategoryId = computed(() => _categoryId.value);

  function rememberCategoryId(categoryId: CategoryId): void {
    _categoryId.value = categoryId;
    setCookie(COOKIE_NAME, String(categoryId), { expiration: getCookieExpiration(), path: "/" });
  }

  return {
    rememberedCategoryId,
    rememberCategoryId,
  };
}
